import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { Field, connect as connectFormik } from 'formik';
import { Circles } from '../../common/loadingComponent';
import { writeErr } from '../../common/logger';
import { ENTITY_STATE } from '../monitoringConstants';
import { popupActions } from '../../../store/popupStore';
import { domainActions } from '../../../store/domainStore';
import { isNullOrUndefined, validateInput } from '../../../store/storeFunctions';
import { apiPost, getHostApi, hasPermission } from '../../../store/apiWrapper';
import Widget from '../../common/widget';
import Message from '../../common/message';
import BbInput from '../../styling/bbInput';
import ColumnWrap from '../../marketingList/columnWrap';

import EditIcon from '../../../img/icons/Upravit';
import SaveIcon from '../../../img/icons/BBicons_Ulozit';

import './createSection.scss';

const DOMAIN = "monitored-list-types";
const CREATE = "CREATE";

class IdentificationSection extends React.Component {
    state = {
        subjectsLoading: false,
        editingName: false,
        subjects: [],
        hasAllFirstLevelPortfolios: null,
    };

    render() {
        return <>
            {this.props.identMessageType && <Message type={this.props.identMessageType} message={this.props.identMessageText} options={{ renderInnerHtml: true }} style={{ marginBottom: "1em" }} />}
            {this.props.mode === CREATE ? this.renderCreateForm() : this.renderEditForm()}
        </>;
    }

    componentDidMount() {
        this.props.ensureDomainData(DOMAIN);

        this.setState({
            subjects: this.props.subjects.map(s => ({ ...s, checked: false, state: ENTITY_STATE.loaded })),
            hasAllFirstLevelPortfolios: this.props.hasAllFirstLevelPortfolios
        });
    }

    renderCreateForm = () => {
        return (
            <>
                <Widget className="create-portfolio-widget" header="Monitoring.Create.NewPortfolio" disableExpand={true} initialExpanded={true}>
                    <div className="columns is-vcentered">
                        <div className="column is-11">
                            <BbInput type='text'
                                label={this.props.translate('Monitoring.Create.PortfolioName')}
                                disabled={this.props.disabled}
                                name="identification.name"
                                placeholder={{ type: 'column' }}
                            />
                            {this.props.sources.requestResult && !this.props.sources.isRequesting && <BbInput type='select-noformik'
                                label={this.props.translate('Monitoring.Create.PortfolioType')} placeholder={{ type: 'column' }}
                                formatOptionLabel={formatOptionLabel}
                                options={this.getMonitoredListTypes()}
                                selectPlaceholder={`${this.props.translate("Common.Select")}...`}
                                onChange={(e) => {
                                    this.props.onTypeChanged(e.value);
                                    this.props.formik.setFieldValue("identification.type", e.value);
                                }}
                            />}
                        </div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <button type="button" onClick={() => this.createClicked()}
                            className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                        >
                            <Translate id="Monitoring.Overview.CreateNewPortfolio"></Translate>
                        </button>
                    </div>
                </Widget>

            </>
        );
    }

    renderEditForm = () => {
        if (this.state.subjectsLoading)
            return <Circles />;

        return (
            <ColumnWrap column="is-12-fullhd is-12-desktop is-12-tablet" style={{ padding: "1em 2em 0.5em 1.175em" }}>
                <div className="columns is-multiline">
                    <div className="column is-6">
                        <div className="monitoring-header-wrapper">
                            {this.state.editingName
                                ? <Field type="text" name="identification.name" placeholder={this.props.translate("Monitoring.Create.PortfolioName")}
                                    className="input form-control" onInput={(e) => validateInput(e)}/>
                                : <h1 className="monitoring-header equal-height">{this.props.formik.values.identification.name}</h1>
                            }
                            {this.props.sharingRole === 0 && <div className="ml-link color">
                                <div className="ml-link-inner">
                                    {this.state.editingName ? <a className='link-internal' onClick={() => this.onNameChangeClicked()}>
                                        <SaveIcon className="ml-link-icon" />
                                        <Translate id="Common.Button.Save" />
                                    </a> : <a className='link-internal' style={{ alignItems: "center" }} onClick={() => this.setState({ editingName: true })}>
                                        <EditIcon className="ml-link-icon" />
                                        <Translate id="Common.Button.Edit" />
                                    </a>}
                                </div>
                            </div>}
                        </div>
                        <div className="field bb-field" style={{ paddingLeft: "0px", paddingTop: "0px" }}>
                            <div className="columns is-multiline">
                                <div className="column is-12">
                                    <div style={{ display: 'inline-flex' }}>
                                        <span>
                                            <Translate id="Monitoring.Create.PortfolioType" />:
                                        </span>
                                    </div>
                                    <div style={{ display: 'inline-flex' }}>
                                        <div style={{ display: 'inline' }}>
                                            <span style={{ paddingLeft: "0.5em", display: 'block', whiteSpace: 'nowrap' }}>
                                                <span>{ReactHtmlParser(this.props.type)}</span>
                                                <sup>{this.props.marketingCountry}</sup>
                                            </span>
                                            {this.props.isA2A && <span style={{ paddingLeft: "0.5em", display: 'block', whiteSpace: 'nowrap' }}>
                                                <Translate id="Monitoring.PortfolioTypeA2A" />
                                            </span>}
                                            {this.props.isFirstLevel === true && <span style={{ paddingLeft: "0.5em", display: 'block', whiteSpace: 'nowrap' }}>
                                                <Translate id="Portfolio.1stLevel" />
                                            </span>}
                                        </div>
                                    </div>
                                </div>
                                {this.props.inactiveOwner && <div className="column is-12" style={{ paddingTop: "0px", color: "red" }}>
                                    <Translate id="Monitoring.Create.InactiveOwner" />
                                </div>}
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div style={{ display: "flex", justifyContent: "flex-end", flexDirection: "row", alignItems: "center", paddingTop: '0.5em' }}>
                            {this.state.subjects.length > 0 && !this.props.isA2A && this.state.hasAllFirstLevelPortfolios === false && hasPermission(null, "Monitoring1stLevel") && this.props.sharingRole === 0 &&
                                <button onClick={() => this.createFirstLevelPortfolios()}
                                    className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                                    <Translate id="Monitoring.Overview.Create1stLevelPortfolios" />
                                </button>
                            }
                            {this.props.sharingRole === 0 && <button onClick={() => this.sharePortfolio()}
                                className={classnames("bb-button is-primary gradient-1", { "is-square": localStorage.locales_button_style === "square" })}>
                                <Translate id="Monitoring.Share" />
                            </button>}
                        </div>
                    </div>
                </div>
            </ColumnWrap>
        );
    }

    createFirstLevelPortfolios = () => {
        this.setState({ subjectsLoading: true });
        apiPost(`${getHostApi()}/api/portfolio/${this.getPortfolioId()}/1stLevel`, {}, null,
            (s) => {
                if (s.data.isSuccess) {
                    this.setState({ hasAllFirstLevelPortfolios: true });
                    this.props.changeIdentMessage("success", this.props.translate("Portfolio.Search.PortfolioUpdated"));
                } else {
                    this.props.changeIdentMessage("error", this.props.translate(s.data.exception, isNullOrUndefined(s.data.exceptionData) ? undefined : s.data.exceptionData));
                }
            },
            (e) => {
                writeErr(e);
                this.props.changeIdentMessage("error", this.props.translate(e.data.error.message || "Common.Error"));
            },
            () => this.setState({ subjectsLoading: false })
        );
    }

    getPortfolioId = () => parseInt(window.location.pathname.match(/\d+/)[0]);

    getMonitoredListTypes = () => {
        if (this.props[DOMAIN].isRequesting || this.props[DOMAIN].requestResult === null) {
            return [];
        }
        else {
            let result = [];
            this.props[DOMAIN].requestResult.map((s => {
                result.push({ value: s.value, label: s.label, shortening: s.shortening });
            }))
            return result;
        }
    }

    onNameChangeClicked = () => {
        this.setState({ editingName: false });
        this.createClicked();
    }

    createClicked = () => {
        if (this.props.formik.values.identification.name === "") {
            this.setState({ editingName: true });
            this.props.changeIdentMessage("error", this.props.translate('Form.Validation.Required').replace('${name}', this.props.translate('Monitoring.Create.PortfolioName')));
        } else if (this.props.formik.values.identification.name.length > 50) {
            this.setState({ editingName: true });
            this.props.changeIdentMessage("error", this.props.translate('Monitoring.Create.Validation.MaxNameLength'));
        } else if (this.props.formik.values.identification.type === "") {
            this.props.changeIdentMessage("error", this.props.translate('Form.Validation.Required').replace('${name}', this.props.translate('Monitoring.Create.PortfolioType')));
        }
        else
            this.props.onSubmit();
    }

    sharePortfolio = () => {
        this.props.showPopup("sharePortfolio", {
            open: true,
            close: () => this.props.hidePopup(),
            portfolioId: this.getPortfolioId()
        });
    }
}

const formatOptionLabel = ({ value, label, shortening }) => (
    <div style={{ display: "flex" }}>
        <div>{label.replace("<br />", " - ")}<sup>{shortening}</sup></div>
    </div>
);

export default withLocalize(connectFormik(connect(
    state => state.domain,
    dispatch => bindActionCreators(({ ...domainActions, ...popupActions }), dispatch),
)(IdentificationSection)));